export const name: string = 'Calendar';
export const group = 'Charting';
export const moduleName: string = 'pdc-widget-calendar';
export const icon: string = 'list-alt';
export const namespace: string = 'business-intelligence';
export const themeId: string = 'widget-calendar'; //VR: Theme ID (to SELECT and EXPAND it in Theme dialog)
//export const priority: number = 1;

//export const UseExternalDataQueryForPeriodTypes = false; //LL: 30.09.23
export const UseExternalDataQueryForPeriodTypes = true; //LL: 30.09.23

//LL: 02.08.23: new Calendar   from CalendarGrid
//  ARGB:   #ffbd0120 - red   # fff9e1a3 -бежевый  ff623a7b - violet   ffededed - light gray
//        ffe97b31 - orange   ff426ead - blue   ffc0c2df - light gray-violet
export const Colors = {
    Almindelig_sygdom_BorderColor: '#bd0120',  // - red   'x'
    Arbejdsskade_BorderColor: '#f9e1a3',  // - бежевый
    p56_sygdom_BorderColor: '#623a7b',  // - violet
    Fri_ferie_BackColor: '#e7e7e7',  // - light gray  'g'   or ededed
    Ressourceforlob_BorderColor: '#e97b31',  // - orange
    Delvis_sygdom_BorderColor: '#426ead',  // - blue  'b'
    Barns_sygdom_BorderColor: '#c0c2df',  // - light gray-violet
    Langtidssyg_sygdom_BorderColor: '#ff8080', // mild red // 'Sygdom - langtidssyg':  //LL: длительная болезнь
    EmptyDay_BackColor: '#888888',  // - dark gray  'n'  or bdbdbd
    Holidays_BackColor: '#fae7e7' //LL: 17.08.23: wants different for weekends (Fri_ferie_BackColor) and holidays
};

//LL: 02.08.23: new Calendar   from CalendarGrid
//  §	Section Symbol	&‌sect; (167)  - see https://sites.psu.edu/symbolcodes/codehtml/
export const Texts = {
    Almindelig_sygdom_text: 'Almindelig sygdom',
    Arbejdsskade_text: 'Arbejdsskade',
    p56_sygdom_text: '§56 sygdom', // paragraph  '\u00b7': middle dot  '\u00b6' - for pilcrow
    Fri_ferie_text: 'Fri/ferie',  // slash
    Ressourceforlob_text: 'Ressourceforl' + '\u00f8' + 'b', // 'Ressourceforlob';  // danish letter
    Delvis_sygdom_text: 'Delvis sygdom',
    Barns_sygdom_text: 'Barns sygdom',
    Langtidssyg_sygdom_text: 'Langtidssyg sygdom' //LL: длительная болезнь
};

//LL: 23.08.23: new Calendar  see Gantt/PatternManager
//export const defaultPattern = 'Solid'; // no
//export const PatternList = {
//    Solid: { code: 0, text: 'Solid' },
//    DiagonalRight: { code: 1, text: 'Diagonal Right' },
//    DiagonalRightWide: { code: 2, text: 'Diagonal Right Wide' },
//    DiagonalLeft: { code: 3, text: 'Diagonal Left' },
//    DiagonalLeftWide: { code: 4, text: 'Diagonal Left Wide' },
//    HorizontalLines: { code: 5, text: 'Horizontal Lines' },
//    HorizontalLinesWide: { code: 6, text: 'Horizontal Lines Wide' },
//    VerticalLines: { code: 7, text: 'Vertical Lines' },
//    VerticalLinesWide: { code: 8, text: 'Vertical Lines Wide' }
//    //Checkered: { code: 9, text: 'Checkered' },
//    //CheckeredWide: { code: 10, text: 'Checkered Wide' }, //  CheckeredLarge = 10
//    //CheckeredDiagonal: { code: 14, text: 'Checkered Diagonal' },
//    //DotsSmall: { code: 11, text: 'Dots Small' },
//    //DotsMedium: { code: 12, text: 'Dots Medium' },
//    //DotsLarge: { code: 13, text: 'Dots Large' }
//};
//LL: 28.08.23: by gradient
export const PatternList = {
    //Solid: { code: 0, text: 'Solid' }, //LL: don't use "Solid", it will obscure weekends/holidays color
    DiagonalRight: { code: 1, text: 'Diagonal to Left' }, // 'Diagonal Right'
    //DiagonalRightWide: { code: 2, text: 'Diagonal Right Wide' },
    DiagonalLeft: { code: 3, text: 'Diagonal to Right' }, // 'Diagonal Left'
    //DiagonalLeftWide: { code: 4, text: 'Diagonal Left Wide' },
    HorizontalLine: { code: 5, text: 'Horizontal Line' },
    //HorizontalLinesWide: { code: 6, text: 'Horizontal Lines Wide' },
    VerticalLine: { code: 7, text: 'Vertical Line' },
    //VerticalLinesWide: { code: 8, text: 'Vertical Lines Wide' }
    Cross: { code: 9, text: 'Cross' }
};

//LL: 11.09.23  Calendar from main
export const DisplayValuesList_PeriodTypes = {
    'ShiftTypeT': 'Period Type',
    'ShiftLabelT': 'Period Label',
    'ShiftIdT': 'Period Id'
};

//LL: 11.09.23  Calendar from main
export const HiddenFields_PeriodTypes = {
    InitGrouping: true,
    Sort: true,
    Format: true,
    More: true,
    Label: true
};

//LL: let remain grid ?
export const themeFields = {
    rowHighligtingColor: 'widget-grid-row-highlighting-color',
    showCollapseExpandButton: 'widget-grid-show-collapse-expand-button',
    showCollapseGroupingsByDefault: 'widget-grid-show-collapse-groupings-by-default',
    allowGrouping: 'widget-grid-allow-grouping',
    showFilterRow: 'widget-grid-show-filter-row',
    showToolbar: 'widget-grid-show-grid-toolbar',
    useRowMode: 'widget-grid-use-row-mode'
};
